import {Component, input} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {ToggleButton} from 'primeng/togglebutton';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'elcia-toggle-todo-private',
  imports: [
    ReactiveFormsModule,
    ToggleButton,
    TranslatePipe
  ],
  templateUrl: './toggle-todo-private.html',
  styleUrl: './toggle-todo-private.scss',
})
export class ToggleTodoPrivate {
  control = input.required<FormControl<boolean | null>>();
}
